import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PartnerContextService } from '../services/partner-context.service';

/**
 * Protects everything behind a partner's address.
 *
 * "Authenticated" is always partner-scoped: `getApiKey()` hands out the stored key only
 * while the session belongs to the partner in the URL, so a session for partner A does not
 * open partner B's panel — it sends the user to partner B's own login page.
 */
export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  if (inject(AuthService).getApiKey()) {
    return true;
  }

  return inject(Router).createUrlTree(['/', inject(PartnerContextService).slug, 'login']);
};
